// @core/api/endpoints/subscription/subscribe_tenant.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ProductTenantResponse,
  SubscribeTenantRequest,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Subscribe tenant to product
 * Grants a tenant access to a product with the specified subscription plan. Establishes the tenant's presence in the product ecosystem.
 */
export async function SubscribeTenant(
  tenant_id: string,
  product_id: string,
  data: SubscribeTenantRequest,
  options?: RequestOptions
): Promise<ProductTenantResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tenants/:tenant_id/products/:product_id/subscribe`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  requestPath = requestPath.replace(':product_id', encodeURIComponent(product_id));
  const requestOptions = options;
  return client.post<ProductTenantResponse>(requestPath, data, requestOptions);
}
